export default __webpack_public_path__ + "static/media/Group 3197@2x.bfb51936.png";